import callApiAxiosClient from '../../axios/axios_client';
import { heatmapByHourList } from '../../models';

function getHeatmapByHour(locationId: number, date: string): Promise<heatmapByHourList> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient<heatmapByHourList>({
    method: 'get',
    url: 'programmability/heatmap-by-hour',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    params: {
      locationId: locationId,
      date: date,
    },
  });
}
export default getHeatmapByHour;
